import React, { Component } from 'react';
import Select from 'react-select';
import AddFormModal from './../../../common/AddFormModal'
import update from 'react-addons-update';
import Card from './routeitem';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import $ from 'jquery';
import execAjax from './../../../common/execAjax';
import getCookie from './../../../common/getCookie';
import { ToastContainer, toast } from 'react-toastify';

var imm = require('immutable');
var cx = require('classnames');

function keysrt(key,desc) {
    return function(a,b){
        return desc ? ~~(a[key] < b[key]) : ~~(a[key] > b[key]);
    }
}

export default class extends React.Component {
    constructor (props) {
        super(props)
        const groupId = props.match.params.group_id;
        this.state = {
            editmode: false,
            url: `/admin/routing/sms/groups/${groupId}/routes`,
            routes: [],
            destinations: {},
            carriers: {},
            srcnumbers: {},
            newindex: 0,
            name: ''
        }
    }

    componentDidMount(){
        this.loadFromServer();
    }
    loadFromServer() {
        // var data = {};
        // var opt = {
        //     url: this.state.url,
        //     urlattrs: this.props.urlattrs,
        //     method: 'get',
        //     authToken: getCookie('sessid_admin')
        // };
        // var that = this;

        this.props.childProps.dataProvider.getList(this.state.url, {}, this.props).then(
            response => {
                if (response.data !== undefined) {
                    this.setState({
                        routes: JSON.parse(response.data.data),
                        carriers: response.data.metadata.carriers,
                        destinations: response.data.metadata.destinations,
                        srcnumbers: response.data.metadata.srcnumbers,
                        name: response.data.name
                    })
                } else {
                    toast.error("Something went wrong... backend not reachable. Try to reload page", {})
                }
            }
        );


        // $.when( execAjax(data, opt) ).done(function(data, metadata) {
        //     that.setState({
        //         routes: JSON.parse(data.data),
        //         carriers: data.metadata.carriers,
        //         destinations: data.metadata.destinations,
        //         srcnumbers: data.metadata.srcnumbers,
        //         name: data.name
        //     });
        // }).fail(function(result) {
        //     that.setState({
        //         error: result.msg
        //     });
        // });
    }
    handleupdn(id, dir) {
        const { routes } = this.state;
        var dragIndex = id;
        var hoverIndex = id + dir;
        const dragCard = routes[dragIndex];

        this.setState(update(this.state, {
            routes: {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, dragCard],
                ],
            },
        }));
    }
    moveRoute(dragIndex, hoverIndex) {
        if (!this.state.editmode)
            return;

        const { routes } = this.state;
        const dragCard = routes[dragIndex];

        this.setState(update(this.state, {
            routes: {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, dragCard],
                ],
            },
        }));
    }
    addRoute() {
        var newroutes = this.state.routes;
        var newindex = this.state.newindex;
        var route = {
            id: 'new_' + String(newindex),
            type: 'roundrobin',
            destcode: '',
            srccode: '',
            enabled: false,
            carriers: [],
            srcnumbers: []
        };
        newroutes.push(route);
        newindex++;
        this.setState({
            routes: newroutes,
            newindex: newindex
        });

    }
    handleDelete(index) {
        this.setState({
            routes: update(this.state.routes, {$splice: [[index, 1]]})
        }, this.props.handleRouteChange)
    }
    handleEdit() {
        this.setState({ editmode: true })
    }
    handleSave () {
        this.setState({errorfields: [], errormsg: '', editmode: false});
        
        var opt = {
            url: this.state.url,
            urlattrs: this.props.urlattrs,
            method: 'update',
            authToken: getCookie('sessid_admin')
        };
        var that = this;

        var data = {routes: JSON.stringify(this.state.routes)};
        this.props.childProps.dataProvider.update(this.state.url, {
            id: '',
            data: data,
            previousData: data
        }, this.props)
        .then(response => {
            toast.success('Entry Updated Successfully', {})
            this.setState({
                    data: imm.Map(data),
                    backupdata: imm.Map(data),
                    edit: false
                })
        }).catch(
            (err)=> {
                toast.error(this.errorMessage(err.message), {})
                var result = err.message;
                let flds = []
                if (result !== undefined && result.fields !== undefined) {
                    flds = result.fields;
                }
                this.setState({
                    errorfields: flds
                });           
        })
        // $.when( execAjax(data, opt) ).done(function(data) {
        //     that.setState({
        //         data: that.state.defaults,
        //     });

        //     // toastr.options.timeOut = 5000;
        //     // toastr.options.positionClass = "toast-top-center";
        //     // toastr.options.closeButton = true;
        //     // toastr['success']('Entry Added Successfully');

        // }).fail(function(result) {
        //     if (result != undefined) {
        //         if (result.fields == undefined) {
        //             var flds = [];
        //         } else {
        //             var flds = result.fields;
        //         }
        //         that.setState({
        //             errorfields: flds,
        //             errormsg: result.msg
        //         });
        //     }
        // });
    }
    handleCancel () {
        this.setState({ editmode: false  })
    }
    onChange(index, key, value) {
        const newData = update(this.state.routes, {
            [index]: {[key]: {$set: value}}
        });
        this.setState({routes:  newData });
    }
    render() {
        var routes = this.state.routes;
        return(
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <div className="panel-title">SMS Routing Group: { this.state.name }</div>
                                <div className="panel-options">
                                    {!this.state.editmode &&
                                    <button className="btn btn-edit" onClick={ this.handleEdit.bind(this) }>Edit</button>
                                    }
                                    {this.state.editmode &&
                                    <button className="btn btn-save" onClick={ this.handleSave.bind(this) }>Save</button>
                                    }
                                    {this.state.editmode &&
                                    <button className="btn btn-cancel" onClick={ this.handleCancel.bind(this) }>Cancel</button>
                                    }
                                </div>
                            </div>
                            <div className="panel-body">
                                <div>
                                    <div className="row route-header">
                                        <div className="col-md-1">
                                            Move or Drag
                                        </div>
                                        <div className="col-md-2">
                                            Destination Code
                                        </div>
                                        <div className="col-md-2">
                                            Source Numbers
                                        </div>
                                        <div className="col-md-1">
                                            Type
                                        </div>
                                        <div className="col-md-4">
                                            Carriers
                                        </div>
                                        <div className="col-md-1">
                                            Enabled
                                        </div>
                                        <div className="col-md-1">
                                            Delete
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {
                                                routes.map(function (route, index) {
                                                    return (
                                                        <Card
                                                            className = "route-item"
                                                            key = { route.id }
                                                            id = { route.id }
                                                            route = { route }
                                                            index = { index }
                                                            destinations = { this.state.destinations }
                                                            carriers = { this.state.carriers }
                                                            srcnumbers = { this.state.srcnumbers }
                                                            updn = { this.handleupdn.bind(this, index) }
                                                            moveRoute={this.moveRoute.bind(this)}
                                                            first = { index == 0 }
                                                            last = { index == (routes.length -1) }
                                                            onDelete = { this.handleDelete.bind(this, index) }
                                                            editmode = { this.state.editmode }
                                                            onChange = { this.onChange.bind(this, index) }
                                                        />
                                                        )
                                                }, this)}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-2">
                                            <button className="btn btn-add" onClick={ this.addRoute.bind(this) } disabled = { !this.state.editmode } >Add New Route</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

